import React from 'react'
import { AutoComplete } from 'primereact/autocomplete'

const AdsizeAutocomplete = ({
  name,
  filteredAdSizes,
  searchAdSizes,
  value,
  showCheckBox,
  handleSizeChange,
  idx
}) => {
  return (
    <div className="param-input adpos">
      <AutoComplete
          multiple
          suggestions={filteredAdSizes}
          completeMethod={searchAdSizes}
          name={name}
          value={value}
          disabled={!showCheckBox}
          onChange={e => handleSizeChange(e, idx)}
        />
    </div>
  )
}

export default AdsizeAutocomplete
